import { Navigate } from 'react-router-dom';
import { useAuth, type AdminRole } from '@/contexts/AuthContext';

interface RoleGuardProps {
  required: AdminRole;
  children: React.ReactNode;
}

export function RoleGuard({ required, children }: RoleGuardProps) {
  const { role } = useAuth();

  if (required === 'owner' && role !== 'owner') {
    return <Navigate to="/admin/operations" replace />;
  }

  return <>{children}</>;
}
